import * as React from 'react';
import Popup from "reactjs-popup";
import 'reactjs-popup/dist/index.css';

export function Beacon(props) {
    return (
        <>
            <Popup
                trigger={props.opener}
                position={props.position ? props.position : 'top center'}
                on={['hover', 'focus']}
                arrow={true}
                className={'beacon-popup'}
            >
                {React.createElement(props.content)}
            </Popup>
        </>
    );
}
